import { Icon, type IconName } from '@/components/Icon';
import { navigate } from '@/state/nav';

const ITEMS: { icon: IconName; label: string; sub: string; to: string }[] = [
  { icon: 'paw', label: 'Roster', sub: 'Animals & batches', to: '/roster' },
  { icon: 'photo', label: 'Photo log', sub: 'Daily photos', to: '/photos' },
  { icon: 'doc', label: 'Reports', sub: 'Shift handoffs & summaries', to: '/reports' },
  { icon: 'gear', label: 'Settings', sub: 'Theme, notifications, you', to: '/settings' },
];

export function MoreScreen() {
  return (
    <div class="screen screen--fade-in">
      <header class="header">
        <div>
          <div class="header__title">More</div>
        </div>
      </header>
      <div class="scroll" style={{ gap: 'var(--s-2)', paddingTop: 'var(--s-2)' }}>
        {ITEMS.map((it) => (
          <button
            key={it.to}
            class="card"
            style={{ display: 'flex', alignItems: 'center', gap: 'var(--s-3)', padding: 'var(--s-4)', textAlign: 'left', width: '100%' }}
            onClick={() => navigate(it.to)}
          >
            <span class="suggest-chip__icon" style={{ width: '36px', height: '36px' }}>
              <Icon name={it.icon} />
            </span>
            <span style={{ flex: 1 }}>
              <span class="t-h3" style={{ display: 'block' }}>{it.label}</span>
              <span class="t-meta">{it.sub}</span>
            </span>
            <Icon name="chevron-right" class="t-meta" size={18} />
          </button>
        ))}
      </div>
    </div>
  );
}
